import useGetChartConfig from './useGetChartConfig'

export default useGetChartConfig
